import { marked } from 'marked'
import { Box } from '@mui/material'
import { FS_MD, FS_SM } from '../common/theme'

marked.use({ gfm: true })

export function MarkdownMessage({ content }: { content: string }) {
  const html = marked.parse(content) as string
  return (
    <Box
      dangerouslySetInnerHTML={{ __html: html }}
      sx={{
        fontSize: FS_MD, lineHeight: 1.5,
        '& p': { m: 0 }, '& p + p': { mt: 0.75 },
        '& ul, & ol': { mt: 0.25, mb: 0.25, pl: 2.5 }, '& li': { mb: 0.25 },
        '& h1, & h2, & h3, & h4': { mt: 0.5, mb: 0.5, fontWeight: 700, lineHeight: 1.5 },
        '& h1': { fontSize: '1rem' }, '& h2': { fontSize: '0.925rem' }, '& h3, & h4': { fontSize: '0.9rem' },
        '& code': { fontFamily: 'monospace', fontSize: '0.80rem', bgcolor: 'action.hover', px: 0.5, borderRadius: 0.5 },
        '& pre': { bgcolor: 'action.hover', p: 1, borderRadius: 1, overflowX: 'auto', mt: 0.5, mb: 0.5 },
        '& pre code': { bgcolor: 'transparent', p: 0 },
        '& blockquote': { borderLeft: 3, borderColor: 'divider', pl: 1, ml: 0, opacity: 0.8, mt: 0.5, mb: 0.5 },
        '& a': { color: 'primary.main' }, '& strong': { fontWeight: 700 }, '& img': { display: 'none' },
        '& table': { borderCollapse: 'collapse', width: '100%', mt: 0.5, mb: 0.5 },
        '& th, & td': { border: 1, borderColor: 'divider', px: 1, py: 0.5, fontSize: FS_SM },
        '& th': { fontWeight: 700, bgcolor: 'action.hover' },
      }}
    />
  )
}
